import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../lib/utils';

const Hero = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/about');
    setTimeout(() => {
      const contactSection = document.querySelector('#contact-form');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center">
      {/* Video Background */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Added blue tint overlay */}
        <div className="absolute inset-0 bg-blue-900/40 mix-blend-multiply z-20" />
        <div className="absolute inset-0 bg-primary/70 mix-blend-multiply z-10" />
        <video
          className="w-full h-full object-cover"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          style={{ opacity: 1 }}
        >
          <source
            src="https://videos.pexels.com/video-files/3130182/3130182-uhd_2560_1440_30fps.mp4"
            type="video/mp4"
          />
        </video>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-20">
        <motion.div
          className="max-w-3xl mx-auto text-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-h1 font-display font-semibold text-white mb-6 leading-[1.2]">
            Code Beyond Boundaries
          </h1>
          <p className="text-lg md:text-xl text-gray-100 mb-8 leading-[1.6]">
            Empowering businesses with cutting-edge technology solutions that drive innovation,
            efficiency, and growth in the digital age.
          </p>
          <motion.button
            onClick={handleGetStarted}
            className={cn(
              "group inline-flex items-center gap-2 px-8 py-4 bg-accent text-white rounded-lg font-semibold",
              "hover:bg-accent/90 transition-colors duration-300"
            )}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span>Get Started</span>
            <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;